import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { SUPPORT_EMAIL } from '../api/config';
import { PageShell } from '../components/Layout';

export default function ContactPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <PageShell>
      <div className="max-w-2xl mx-auto px-4 sm:px-6 py-10 md:py-14">
        <h1 className="page-title">Contact</h1>
        <p className="text-ink/60 mt-3">Questions about your search or payment? Reach us by email.</p>

        <div className="mt-10">
          <a href={`mailto:${SUPPORT_EMAIL}`} className="block bg-white border-2 border-forest p-6 hover:shadow-stamp transition-shadow group max-w-md">
            <p className="text-xs font-bold uppercase tracking-wider text-ink/50">Email</p>
            <p className="font-semibold text-forest break-all mt-1 group-hover:text-clay transition-colors">{SUPPORT_EMAIL}</p>
          </a>
        </div>

        <div className="mt-10">
          <Link to="/" className="btn-outline">← Back to search</Link>
        </div>
      </div>
    </PageShell>
  );
}
